import { useLoadboardAccessContext } from 'shared/modules/loadboard/core/loadboard-access/LoadboardAccessContext';
import { LinkAnchor } from 'shared/routing/Links';
import { PostingLoadDTO } from '../../data/dto/PostingLoadDTO';
import { useLoadboardContext } from '../../data/LoadboardContext';
import { trackLoadboardEvent } from '../LoadboardAnalytics';

interface PostingTermsLinkProps {
  load: PostingLoadDTO;
}

export function PostingTermsLink({ load }: PostingTermsLinkProps) {
  const { openAccessDialog } = useLoadboardAccessContext();
  const {
    router: { closePostingScreen },
  } = useLoadboardContext();

  return load.shipper ? (
    <LinkAnchor
      to={`/terms-and-conditions/${load.shipper.guid}`}
      onClick={() => {
        trackLoadboardEvent({ name: 'SLB: Clicked Terms and Conditions' });
      }}
    >
      View Terms and Conditions
    </LinkAnchor>
  ) : (
    <LinkAnchor
      to=""
      onClick={(event) => {
        event.preventDefault();
        openAccessDialog(closePostingScreen);
      }}
    >
      View Terms and Conditions
    </LinkAnchor>
  );
}
